import React from 'react'
import { INRWorkoutSessionHit } from 'interfaces/workout'
import { getCombinationHitColor } from 'lib/hit-combinations'

export interface BarItemProps {
  combination?: boolean
  height: number
  segments?: INRWorkoutSessionHit[]
}

const Bar: React.FC<BarItemProps> = ({ combination = false, height, segments = [] }) => {
  if (!combination) {
    return <div className="ChartEx__bars__bar" style={{ height: height + '%' }} />
  }

  const totalForce = segments.reduce((total, hit) => total + hit.force, 0)

  return (
    <div
      className="ChartEx__bars__bar ChartEx__bars__bar--combination"
      data-segment-count={segments.length}
      style={{ height: height + '%' }}
    >
      {segments.map((hit, index) => (
        <span
          className="ChartEx__bars__segment"
          data-force={hit.force}
          key={`${hit.punchedAt}-${index}`}
          style={{
            backgroundColor: getCombinationHitColor(index),
            height: `${totalForce ? (hit.force / totalForce) * 100 : 0}%`,
          }}
        />
      ))}
    </div>
  )
}

export default Bar
